export default interface User {
  email: string 
  shouldUpdatePassword: boolean
}

export const ADMIN = 'administrator'
export const RT = 'remote-teacher'
export const REFERENT = 'pedagogical-referent' 

export type Role = typeof ADMIN | typeof RT | typeof REFERENT